<ng-container *ngIf="type === 'combobox' || type === 'combobox-filter'">
  <div class="combobox__wrapper">
    <div
      class="label__wrapper combobox"
      [ngClass]="{
        'combobox-open': isOpen,
        'combobox-selected': dropdownPlaceholder !== dropdownPlaceholderDefault,
      }"
      (click)="toggleDropdown()"
      (keydown)="toggleDropdown()"
    >
      <label
        for="combobox"
        [ngClass]="{
          'label__wrapper__placeholder--default':
            dropdownPlaceholder === dropdownPlaceholderDefault,
        }"
        >{{ dropdownPlaceholder }}</label
      >
      <hdi-icon
        [iconName]="icon"
        class="combobox__icon"
        [class.flip]="isOpen"
      />
    </div>
    <input type="checkbox" id="combobox" class="combobox" #combobox />
    <div class="combobox__options" *ngIf="isOpen">
      <ul>
        @for (item of itemList; track item; let idx = $index) {
          <li
            class="combobox combobox__option"
            [ngClass]="{
              'combobox__option--filter': type === 'combobox-filter',
              'combobox__option--active':
                activeItemList === item && type !== 'combobox-filter',
              'combobox__option--filter-active':
                activeItemList === item && type === 'combobox-filter',
              'combobox__option--active-bold':
                activeItemList === item &&
                item !== dropdownPlaceholderDefault &&
                type !== 'combobox-filter',
            }"
            (click)="selectItemList(idx)"
            (keydown)="selectItemList(idx)"
          >
            {{ item }}
          </li>
        }
      </ul>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="type === 'default'">
  <div class="dropdown">
    <hdi-button
      [type]="dropdown"
      [iconName]="iconButton"
      [label]="dropdownHeader | capitalize"
      (click)="toggleDropdown()"
      (keydown)="toggleDropdown()"
      [isOpen]="isOpen"
    ></hdi-button>
    <div
      class="dropdown_menu"
      aria-labelledby="dropdown_button"
      [class.show]="isOpen"
    >
      <ng-container *ngIf="items">
        @for (item of items; track item; let idx = $index) {
          <div
            class="dropdown_item"
            [ngClass]="{ 'dropdown_item--active': activeItem === item }"
            (click)="selectItem(idx)"
            (keydown)="selectItem(idx)"
          >
            <a class="dropdown_item__link">{{ item.label }}</a>
          </div>
        }
      </ng-container>
      <ng-content></ng-content>
    </div>
  </div>
</ng-container>
